import React from "react";
import ErrorImg from "../../../assets/images/404.png"

export const AccessDenied = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        color: "#d32f2f",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        textAlign: "center",
        padding: "20px",
      }}
    >
      <img src={ErrorImg} alt="ErrorImg" />
      <div className="mt-[-20px]" >
        <h2 className="text-[#3f4a66] text-[35px] font-[700] " style={{ marginBottom: "10px" }}>Oops! Access Denied</h2>
        <p className="text-[16px] font-[500] text-[#3f4a66]" >
          You don’t have permission to view this page. if you believe this is an error,
          <br />please contact the site admin.
        </p>
      </div>
    </div>
  );
};
